import * as yup from 'yup';
import { TapStatusType, TapType } from '../types';

export const createTapsDialogSchema = yup.object().shape({
  position: yup.number().required().label('Length'),
  tBarNumber: yup.number().nullable().default(null).label('T-Bar number'),
  barId: yup.string().nullable().default(null).label('Font'),
  remoteCoolerId: yup.string().nullable().default(null).label('Remote cooler'),
  fobId: yup.string().nullable().default(null).label('Fob'),
  productId: yup.string().nullable().default(null).label('Product'),
  shiftTaps: yup.boolean().nullable().default(false).label('Shift taps'),
  tapId: yup.string().nullable().default(null).label('Tap id'),
  pythonId: yup.string().nullable().default(null).label('Python id'),
  lineLength: yup
    .number()
    .transform((value, originalValue) => {
      return originalValue === '' ? null : value;
    })
    .nullable()
    .default(null)
    .label('Line length'),
  status: yup.mixed<TapStatusType>().oneOf(Object.values(TapStatusType)).required().label('Status'),
  type: yup.mixed<TapType>().oneOf(Object.values(TapType)).required().label('Type')
});

export const createBulkTapsDialogSchema = yup.object().shape({
  barId: yup.string().nullable().default(null).label('Bar id'),
  quantity: yup.number().required().label('Quantity'),
  status: yup.mixed<TapStatusType>().oneOf(Object.values(TapStatusType)).required().label('Status'),
  pythonId: yup.string().nullable().default(null).label('Python id'),
  fobId: yup.string().nullable().default(null).label('Fob id'),
  remoteCoolerId: yup.string().nullable().default(null).label('Remote cooler id'),
  productId: yup.string().nullable().default(null).label('Product id'),
  lineLength: yup.number().nullable().default(null).label('Line length'),
  tBarNumber: yup.number().nullable().default(null).label('T-Bar number'),
  type: yup.mixed<TapType>().oneOf(Object.values(TapType)).required().label('Type')
});
